const resolvers = {};

const schemaExtensionResolvers = {};

export { resolvers, schemaExtensionResolvers };
